<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex mb-3">
          <div class="pl-1">
            <h4>Lịch sử Vào/Ra</h4>
          </div>
          <div class="pr-1" style="width: 230px">
            <!-- <h4>Kỳ tháng</h4> -->
            <el-select
              class="el-input__filter"
              v-model="salaryPeriodId"
              clearable
              filterable
              @change="fn_selectTime()"
              @sort-change="fn_tableSortChange"
            >
              <el-option
                v-for="item in dataSalaryPeriod"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-table">
            <el-table :data="mData.tableRules.data" border style="width: 100%">
              <!-- :header-cell-style="{ backgroundColor: 'var(--orange)' }" -->
              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.skip + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="employee_no"
                label="Mã chấm công"
                min-width="150"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="time"
                label="Thời gian"
                min-width="150"
                align="center"
                :sortable="mData.tableRules.allowSorting"
              >
                <template slot-scope="scope">
                  {{ fn_formatDatetimeToSeconds(scope.row.time) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="serial"
                label="Thiết bị"
                min-width="180"
                align="center"
              ></el-table-column>
            </el-table>
            <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
              <div class="col-md-4">
                <div v-if="mData.tableRules.allowSelect">
                  {{ aLang.c_select }}:
                  {{ mData.tableRules.recordSelected.length }}
                </div>
              </div>
              <div class="col-md-8 text-right">
                <el-pagination
                  @size-change="fn_tableSizeChange"
                  @current-change="fn_tableCurentChange"
                  @prev-click="fn_tablePrevClick"
                  @next-click="fn_tableNextClick"
                  :page-sizes="mData.tableRules.lengthMenu"
                  :page-size="mData.tableRules.limit"
                  :current-page="mData.tableRules.page"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="mData.tableRules.total"
                  :pager-count="5"
                ></el-pagination>
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MethodService from "../../../../service/MethodService";
import EmployeeWorkSheetModel from "./EmployeeWorkSheetModel";
import TimeKeepingLogApi from "../../../../moduleApi/TimeKeepingLogApi";
import TimeKeepingRawCurrentApi from "../../../../moduleApi/TimeKeepingRawCurrentApi";
import SalaryPeriodApi from "../../../../moduleApi/SalaryPeriodApi";

export default {
  data() {
    return {
      salaryPeriodId: undefined,
      currentUser: {},
      currentCompany: {},
      mData: {
        data: [],
        moduleName: "EntryAndExitHistory", //requied
        tableRules: MethodService.copyObject(EmployeeWorkSheetModel.tableRules),
        dataDefault: {},
        dataPerPage: [],
      },
      totalData: [],
      dataSalaryPeriod: [],
      timeKeepingLogApiRes: "",
      timeKeepingLogEmployeeApiRes: "",
      dataFilter: {},
      currentEmployeeInfo: MethodService.getEmployeeInfo(),
    };
  },

  methods: {
    async fn_initData() {
      this.currentCompany = MethodService.getCompanyInfo();
      this.currentUser = MethodService.getCurrentUser();
      const salaryPeriodApiRes = await SalaryPeriodApi.list({
        sort: "-created_at",
      });
      if (salaryPeriodApiRes.result && salaryPeriodApiRes.result.length > 0) {
        this.dataSalaryPeriod = salaryPeriodApiRes.result;
      }
      this.salaryPeriodId = this.$route.query.salaryPeriodId;
      await this.fn_selectTime();
    },

    async fn_initTable() {
      let dataFilter = {};
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = "999999";
        dataFilter.skip = this.mData.tableRules.skip;
      }
      this.$router
        .replace({
          name: "Admin-Timekeeping-Employee-" + this.mData.moduleName,
          query: {
            salaryPeriodId: this.salaryPeriodId,
            limit: this.mData.tableRules.limit,
            skip: this.mData.tableRules.skip,
            page: this.mData.tableRules.page,
          },
        })
        .catch((err) => {});

      this.dataSalaryPeriod.forEach(async (item) => {
        if (item.id == this.salaryPeriodId) {
          // to get total
          const timeKeepingLogApi = TimeKeepingLogApi.list({
            filters:
              "employee_id=" +
              this.currentUser.id +
              "&company_id=" +
              this.currentCompany.id +
              "&time>=" +
              item.from_date +
              "&time<=" +
              item.before_to_date,
            fields: "id,time,employee_id,company_id",
            limit: 9999999,
          });
          this.dataFilter = {
            employee_no: this.currentEmployeeInfo.employee_no,
            start_time: new Date(item.from_date).toISOString(),
            end_time: new Date(item.before_to_date).toISOString(),
            sort: "-time",
            limit: this.mData.tableRules.limit,
            skip: this.mData.tableRules.skip,
          };
          const timeKeepingLogEmployeeApi =
            await TimeKeepingRawCurrentApi.GetTimeKeepingLog(this.dataFilter);

          this.timeKeepingLogApiRes = [];
          this.timeKeepingLogEmployeeApiRes = [];
          await Promise.all([
            timeKeepingLogApi,
            timeKeepingLogEmployeeApi,
          ]).then((value) => {
            if (
              value[0].meta.total > 0 &&
              value[1].result &&
              value[1].result.result &&
              value[1].result.result.length > 0
            ) {
              this.timeKeepingLogApiRes = value[0];
              this.timeKeepingLogEmployeeApiRes = value[1];
            } else {
              this.timeKeepingLogApiRes = [];
              this.timeKeepingLogEmployeeApiRes = [];
            }
          });
          if (
            this.timeKeepingLogEmployeeApiRes.result &&
            this.timeKeepingLogEmployeeApiRes.result.result &&
            this.timeKeepingLogEmployeeApiRes.result.result.length > 0
          ) {
            this.mData.tableRules.total = this.timeKeepingLogEmployeeApiRes.meta.total;
            this.mData.tableRules.data = this.fn_changeData(
              this.timeKeepingLogEmployeeApiRes.result.result
            );
          } else {
            this.mData.tableRules.data = [];
            this.mData.tableRules.total = 0;
          }

          if (this.mData.tableRules.data) {
            this.mData.tableRules.page =
              this.mData.tableRules.skip / this.mData.tableRules.limit + 1;
            if (
              this.mData.tableRules.skip == this.mData.tableRules.total &&
              this.mData.tableRules.skip != 0
            ) {
              this.mData.tableRules.skip = 0;
              this.mData.tableRules.page = 1;
            }
          }
        }
      });
    },

    fn_selectTime() {
      this.mData.tableRules.page = 1;
      this.mData.tableRules.skip = 0;
      this.fn_initTable();
    },

    fn_changeData(resData) {
      resData.forEach((item) => {
        if (item.from_date) {
          item.from_date = MethodService.formatDate(item.from_date, "datetime");
        }
        if (item.before_to_date) {
          item.before_to_date = MethodService.formatDate(
            item.before_to_date,
            "datetime"
          );
        }
      });
      return resData;
    },

    fn_formatDatetimeToSeconds(val) {
      return MethodService.formatDateToSeconds(val);
    },

    //event table
    async fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = 1;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = -1;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.mData.tableRules.data = [];
      await this.fn_initTable();
    },

    //event table by transmitting skip and limit
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
      this.$forceUpdate();
    },

    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.skip =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },
  },

  //run after render view
  created() {
    this.fn_initData();
  },
  mounted() {},
};
</script>
<style scoped>
::v-deep .el-input__filter .el-input__inner {
  text-overflow: ellipsis;
}
</style>
